import { cx } from '@linaria/core';
import { CSSProperties, memo, useState } from 'react';
import CircularProgress from '../../CircularProgress';
import Loading from '../../Loading';
import "./IFrame.linaria.module.css!=!./IFrame?./IFrame.linaria.module.css?css=H4sIAAAAAAAAA12S226EIBCG7/saTS/diHtK6cMQEFAqOi6guEv67s0ewMXLL/8348zIjrqeUEMQGw/Q1bscg9RiKbgyonYKBlyDnvrh5+/j4fUdaau+/z2FEax6CEZo6tQsotJZgo7zxXsTYBZGavC4VZyL1KTiZDqdJbI5BUbrrjEwDbyoQYPBn1LKWPRtCXKLV7MOXNlR0yu+TxpjUREE9gLVHFqhmtZhVJZfMZ2vKfWKuzYLdRkH3mCav1g2G2hEkJ8aOxw3uJZcMZ0cxALGiOKjbA45PY9tW6OGDpdR9hfSsfMw38KtUAMXC0bpw/DeJ1EYKedqaAoH49pHi0wWW5mBc9C/+V3md1tfC+nebJ3Zemubx19I+l5GgYHhwqwJXV7r5vS8TWPAr+sz9q4mys6YZDoSiaaGiZyeMqNWWbw+grMmZj/djuH18sryPt8/J0mPNysDAAA="
const iframeRootStyles = "atm_ar_1bp4okc atm_mk_h2mmj6 atm_ks_15vqwwr atm_2d_u67f1s atm_9s_1txwivl atm_e2_1osqo2v atm_vy_1osqo2v";
const containerStyles = "atm_l0_15vqwwr atm_l1_1wugsn5 atm_9s_1txwivl atm_e2_1osqo2v atm_bb_idpfg4 atm_vy_1osqo2v atm_wq_kb7nvz";
const iframeStyles = "atm_e2_1osqo2v atm_vy_1osqo2v atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4 atm_3f_idpfg4 atm_ax_kb7nvz atm_bb_kb7nvz atm_ap_f1ugbe";
const stylesLoading = "atm_7l_r3uz5";
interface IFrameProps {
  ageGatedContent?: boolean;
  allowFullScreen?: boolean;
  className?: string;
  disableScrolling?: boolean;
  heightOverride?: number;
  hideLoadingText?: boolean;
  iFrameClassName?: string;
  minHeightOverride?: string;
  // Applied directly to the <iframe>. Intentional direct-inline: the token
  // purchase flow passes arbitrary per-payment-processor styling
  // (processorExtras) that varies at runtime and must reach the iframe itself.
  style?: CSSProperties;
  src: string;
}
const IFrame = memo<IFrameProps>(props => {
  const {
    allowFullScreen,
    disableScrolling,
    heightOverride,
    hideLoadingText,
    minHeightOverride,
    iFrameClassName,
    className,
    style,
    src
  } = props;
  const [loading, setLoading] = useState(true);
  return <div data-testid="iFrame__Root" className={cx(iframeRootStyles, className)}>
            {loading && <Loading className={stylesLoading} hideText={hideLoadingText}>
                    <CircularProgress />
                </Loading>}
            <div className={containerStyles}>
                <iframe allowFullScreen={allowFullScreen}
      // this is @deprecated but without it we still get a border
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      frameBorder="0" src={src} onLoad={() => {
        setLoading(false);
      }} {...disableScrolling ? {
        scrolling: 'no'
      } : {}} className={cx(props.ageGatedContent ? 'mfc-image-asset' : '', iframeStyles, iFrameClassName)} style={{
        ...(heightOverride ? {
          height: heightOverride
        } : null),
        ...(minHeightOverride ? {
          minHeight: minHeightOverride
        } : null),
        ...style
      }} />
            </div>
        </div>;
});
export default IFrame;